// DepartmentDropdown.js

import React, { useEffect, useState, useRef } from "react";
import { Form, Select } from 'antd';
import StorageListApi from "../../Apis/StorageListApi";

const StorageSelectProduction = ({ filterHot = false }) => {

    const [Allergens, setAllergens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const isFirstLoad = useRef(true);

    const fetchAllergens = async (reset = false) => {
        try {
            setLoading(true);
            
            // If reset is true, start from page 0
            const currentPage = reset ? 0 : page;
            
            StorageListApi.ListStorage(currentPage, 20)
                .then((response) => {
                    setTotalPageNew(response.totalPages);
                    
                    // Filter storages: keep only those with sensorDTOList and apply hot filter
                    let filteredStorages = response?.payloadDto?.filter(item => item.sensorDTOList);
                    
                    // Apply hot filter if filterHot is false (only show cold storages)
                    if (filterHot === false) {
                        filteredStorages = filteredStorages?.filter(item => item.hot === false);
                    }
                    
                    if (reset) {
                        // Replace the list completely
                        setAllergens(filteredStorages);
                    } else {
                        // Append new items, avoiding duplicates
                        setAllergens(prevDepartments => {
                            const existingIds = new Set(prevDepartments.map(item => item.id));
                            const newItems = filteredStorages.filter(item => !existingIds.has(item.id));
                            return [...prevDepartments, ...newItems];
                        });
                    }
                    
                    setPage(currentPage + 1);
                    setHasMore(currentPage + 1 < response.totalPages);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setLoading(false);
        }
    };
    
    const handleScroll = (e) => {
        const target = e.target;
        const bottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 10;
        
        if (bottom && !loading && hasMore) {
            fetchAllergens(false);
        }
    };
    
    useEffect(() => {
        // Reset everything when filterHot changes
        setAllergens([]);
        setPage(0);
        setHasMore(true);
        isFirstLoad.current = true;
        fetchAllergens(true);
    }, [filterHot]);
    
    useEffect(() => {
        // Initial load
        if (isFirstLoad.current) {
            isFirstLoad.current = false;
            fetchAllergens(true);
        }
    }, []);

    return (
        <>
            <Form.Item
                name="storageUnit"
                label="Storage Unit :"
                className="text-lable"
                rules={[
                    {
                        required: true,
                        message: "Please Select Storage Unit.",
                    },
                ]}
            >
                <Select
                    className="control-Select mb-1"
                    placeholder={filterHot === false ? "Select Cold Storage Unit" : "Select Storage Unit"}
                    onPopupScroll={handleScroll}
                    loading={loading}
                >
                    {Allergens.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.name} ({option.temperatureMinInCelsius}'C - {option.temperatureMaxInCelsius}'C)
                            {option.hot === true && <span style={{ color: 'red', marginLeft: '8px' }}>(Hot)</span>}
                            {option.hot === false && <span style={{ color: 'blue', marginLeft: '8px' }}>(Cold)</span>}
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
        </>
    );
};

export default StorageSelectProduction;